function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchinputFind = function SvgLivemapSearchinputFind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.632 12.364A6.268 6.268 0 1 1 12.364 6.1a6.268 6.268 0 0 1 6.268 6.264zm.169 5.074a8.2 8.2 0 1 0-1.363 1.362l6.084 6.084a.964.964 0 0 0 1.363-1.363z",
    style: {
      fill: "#8f99a2",
      stroke: "#8f99a2",
      strokeWidth: ".5px",
      fillRule: "evenodd"
    },
    transform: "translate(-.667 -.668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z",
    "data-name": "Rectangle 4574",
    style: {
      fill: "none"
    }
  }));
};
export default SvgLivemapSearchinputFind;